module.exports = __webpack_public_path__ + "img/bnaner1-home.fb35cdd7.png";